import * as PubSub from "pubsub-js";
import { FlowStates } from "./FlowStates";

export enum SignalEvents {
  CAPTURE_IMAGE = "CAPTURE_IMAGE",
  LOCAL_DECODE_STARTED = "LOCAL_DECODE_STARTED",
  PAUSE_VIDEO_ACTIVITIES = "PAUSE_VIDEO_ACTIVITIES",
  RESET_FOR_NEW_IMAGE = "RESET_FOR_NEW_IMAGE",
  SET_FLOW_STATE = "SET_FLOW_STATE",
}

export interface CaptureImageData {
  decodeNow: boolean;
}

export interface PauseVideoActivitiesData {
  paused: boolean;
}

export interface SetFlowStateData {
  flowState: FlowStates;
}

export class PubSubEvents {

  /******* Publish *******/

  public static captureImage = (decodeNow: boolean) => {
    const data: CaptureImageData = { decodeNow };
    PubSub.publish(SignalEvents.CAPTURE_IMAGE, data);
  };

  public static setPauseVideoActivities = (paused: boolean) => {
    const data: PauseVideoActivitiesData = { paused };
    PubSub.publish(SignalEvents.PAUSE_VIDEO_ACTIVITIES, data);
  };

  public static resetForNewImage = () => {
    PubSub.publish(SignalEvents.RESET_FOR_NEW_IMAGE, {});
  };

  public static localDecodeStarted = () => {
    PubSub.publish(SignalEvents.LOCAL_DECODE_STARTED, {});
  };

  public static setFlowState = (flowState: FlowStates) => {
    const data: SetFlowStateData = {flowState};
    PubSub.publish(SignalEvents.SET_FLOW_STATE, data);
  };

  /******* Subscribe *******/

  public static subscribeLocalDecodeStarted = (onEvent: () => void) => {
    PubSub.subscribe(SignalEvents.LOCAL_DECODE_STARTED, onEvent);
  };

  public static subscribeSetPauseVideoActivities = (onEvent: (msg: any, data: PauseVideoActivitiesData) => void) => {
    PubSub.subscribe(SignalEvents.PAUSE_VIDEO_ACTIVITIES, onEvent);
  };

  public static subscribeResetForNewImage = (onEvent: () => void) => {
    PubSub.subscribe(SignalEvents.RESET_FOR_NEW_IMAGE, onEvent);
  };

  public static subscribeSetFlowState = (onEvent: (msg: any, data: SetFlowStateData) => void) => {
    PubSub.subscribe(SignalEvents.SET_FLOW_STATE, onEvent);
  };
}



// WEBPACK FOOTER //
// ./src/constants/PubSubEvents.ts